import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "accueil", label: "Accueil", testId: "topnav-accueil" },
  { id: "histoire", label: "Histoire", testId: "topnav-histoire" },
  { id: "famille", label: "Famille", testId: "topnav-famille" },
  { id: "programme", label: "Programme", testId: "topnav-programme" },
  { id: "galerie", label: "Galerie", testId: "topnav-galerie" },
  { id: "hommage", label: "Hommage", testId: "topnav-hommage" },
  { href: "/documents", label: "Documents", testId: "topnav-documents" },
];

export default function TopBar() {
  return (
    <header className="fixed inset-x-0 top-0 z-40 hidden mix-blend-difference md:block">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-8 py-5">
        <button
          data-testid="topnav-logo"
          onClick={() => scrollToId("accueil")}
          className="font-display text-lg font-semibold tracking-[0.2em] text-white"
        >
          MÉMORIUM
        </button>
        <nav className="flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={l.testId}
              onClick={() => (l.href ? (window.location.href = l.href) : scrollToId(l.id))}
              className="text-[11px] font-medium uppercase tracking-[0.22em] text-white/80 transition-colors duration-300 hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}
